/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import useToggle from '../../hooks/useToggle';

function PasswordField({
  label,
  className,
  labelstyle,
  labeldarkstyle,
  classNamedark,
  eyeiconstyle,
  fieldName,
  register,
  errors,
  placeHolder,
  isRequired,
  minimLength,
  maxLength,
  mandatory,
  hideErrors,
  customErrorMessage = undefined,
}) {
  let classNames = labelstyle;
  let classNamess = className;
  const validationOptions = {};
  if (maxLength) {
    Object.assign(validationOptions, {
      maxLength: {
        value: maxLength,
        message: `${label} must be maximum of ${maxLength}.`,
      },
    });
  }

  if (localStorage.getItem('theme') === 'dark') {
    classNames = labeldarkstyle;
    classNamess = classNamedark;
  }
  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };
  const [type, setType] = useToggle();
  return (
    <div className="form-group">
      <label htmlFor={fieldName} className={classNames ?? labelstyle}>
        {label ?? ''}
      </label>
      {mandatory || isRequired ? (
        <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
      ) : (
        <span />
      )}
      <input
        type={type ? 'text' : 'password'}
        className={classNamess ?? className}
        onKeyDown={handleKeyDown}
        placeholder={placeHolder}
        data-toggle="tooltip"
        data-placement="top"
        title="Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character."
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...register(fieldName, {
          required: {
            value: isRequired,
            message: `${label} is required.`,
          },
          minLength: {
            value: hideErrors ? 0 : minimLength,
            message: `${label} must be minimum ${minimLength ?? 8}.`,
          },
          pattern: {
            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
            message: `${label} must contain at least one uppercase letter, one lowercase letter, one number, and one special character.`,
          },
          ...validationOptions,
        })}
      />
      <span className={eyeiconstyle ?? 'password_show'} onClick={setType}>
        {!type ? <i className="fa fa-eye-slash" /> : <i className="fa fa-eye" />}
      </span>
      {customErrorMessage ? (
        <p
          style={{
            color: 'red',
            marginTop: '5px',
            fontSize: '14px',
          }}
        >
          {customErrorMessage}
        </p>
      ) : (
        <p
          style={{
            color: 'red',
            marginTop: '5px',
            fontSize: '14px',
          }}
        >
          {' '}
          {
            // Shows if error exist
            errors[fieldName] && errors[fieldName].message
          }{' '}
        </p>
      )}
    </div>
  );
}

PasswordField.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string.isRequired,
  eyeiconstyle: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  placeHolder: PropTypes.string,
  isRequired: PropTypes.bool,
  minimLength: PropTypes.number,
  labelstyle: PropTypes.string.isRequired,
  mandatory: PropTypes.bool,
  labeldarkstyle: PropTypes.string,
  classNamedark: PropTypes.string,
  hideErrors: PropTypes.bool,
};
PasswordField.defaultProps = {
  mandatory: false,
  isRequired: false,
  labeldarkstyle: null,
  classNamedark: null,
  label: 'Password',
  placeHolder: 'Password',
  minimLength: 8,
  hideErrors: false,
};
export default PasswordField;
